import { AnalyticGoals, AnalyticsService } from 'shared/mechanics/analytics';
import { SiteSection, MenuItems } from '../model';

export interface MenuProps {
	activeSection: SiteSection;
}

function tryTrackAnalyticsGoal(goal: AnalyticGoals | undefined) {
	if (!goal)
		return;

	AnalyticsService.onGoalReached(goal);
}

export const MenuDesktopComponent = (props: MenuProps) => {
	return (
		<ul className="menu">
			{ 
				MenuItems.map(menuItem => {
					return (
						<li key={menuItem.section}>
							<a href={menuItem.href} className={ props.activeSection == menuItem.section ? 'active' : ''} onClick={() => tryTrackAnalyticsGoal(menuItem.analyticsGoal)}>
								{menuItem.title}
							</a>
						</li>
					)
				})
			}
		</ul>
	);
}